function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49 5.551l-.014.001a.49.49 0 01-.061-.005l.075.004a.492.492 0 01-.163-.026.048.048 0 00-.016-.008.345.345 0 01-.06-.027c-.006-.005-.013-.008-.019-.012a.218.218 0 01-.03-.02l-.023-.018a.492.492 0 01-.011-.01l.034.029a.491.491 0 01-.085-.079l-.008-.01a.37.37 0 01-.038-.053l-.016-.03a.337.337 0 01-.035-.085.39.39 0 01-.01-.038l-.002-.015-.004-.027A.492.492 0 011 5.078V.49a.49.49 0 01.972-.088L1.98.49l-.001 3.258a8.105 8.105 0 0110.361-.813 8.006 8.006 0 01.077 12.97.49.49 0 01-.579-.79 7.026 7.026 0 00-.066-11.382 7.124 7.124 0 00-9.23.838h3.52c.24 0 .44.174.481.402l.008.088a.49.49 0 01-.402.482l-.088.008H1.49z",
  fillRule: "evenodd"
});

function SvgActionUndoM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionUndoM);
export default __webpack_public_path__ + "static/media/action-undo--m.3c9e565c.svg";
export { ForwardRef as ReactComponent };